import React from 'react';
import { SkeletonLabel } from '@noths/polaris-client-ribbons-design-system';
import { getDeliveryByEventName, priceFormatter } from '@noths/polaris-client-utils';
import { CurrencyCode, DeliveryByEvent } from '@noths/polaris-dev-ts-types';
import * as R from 'ramda';

import { DeliveryOptionInfo } from 'src/components/molecules/DeliveryBlock/components/DeliveryBlock';
import { copy } from '../constants';
import * as styles from '../styles';
import { getReplacedPlaceholder } from '../utils';
import { MoreOptionsTooltip } from './MoreOptionsTooltip';
interface Props {
  deliveryByEvent: DeliveryByEvent;
  currency: CurrencyCode;
  isLoading: boolean;
  deliveryOptions: DeliveryOptionInfo[];
  cheapestDeliveryOptionPrice: number | null;
  onTooltipClick: (concatenatedDeliveryOptionsCode: string) => void;
}

export const getDeliveryByEventLabel = R.compose(
  getReplacedPlaceholder(copy.DELIVERY_EVENT_LABEL),
  getDeliveryByEventName,
);

export const DeliveryEvent = ({
  currency,
  deliveryByEvent,
  isLoading,
  deliveryOptions,
  cheapestDeliveryOptionPrice,
  onTooltipClick,
}: Props) => {
  if (isLoading) {
    return (
      <div css={styles.skeletonWrapper}>
        <SkeletonLabel />
        <div css={styles.skeletonTooltipWrapper}>
          <SkeletonLabel labelHeight="SM" />
          <SkeletonLabel labelHeight="SM" css={styles.tooltipIcon} />
        </div>
      </div>
    );
  }

  if (cheapestDeliveryOptionPrice == null) {
    return null;
  }

  return (
    <div css={styles.deliveryEventWrapper}>
      <div css={styles.labelWrapper}>
        <p css={styles.label}>
          {`${getDeliveryByEventLabel(deliveryByEvent.eventName)} ${
            cheapestDeliveryOptionPrice === 0
              ? 'free'
              : priceFormatter(currency, cheapestDeliveryOptionPrice, false)
          }`}
        </p>
      </div>
      <MoreOptionsTooltip
        deliveryOptions={deliveryOptions}
        {...deliveryByEvent}
        onTooltipClick={onTooltipClick}
      />
    </div>
  );
};
